/**
 * Helper único para `<Source>`: GeoJSON estático servido por la SPA en
 * `/maps/<file>.geojson` (copy desde data/final/ via scripts/sync-maps.mjs).
 *
 * El visor antes soportaba también PMTiles vector tiles vía R2/CDN, pero
 * mapbox-gl-js 3.x removió `addProtocol` (decisión de licencia), así que
 * `pmtiles://` no resolvía. Activarlo requería migrar a MapLibre o servir
 * MVT desde el BFF — descartado por el equipo. Hoy: GeoJSON only.
 */

export function sourceProps(url: string): { type: 'geojson'; data: string } {
  return { type: 'geojson' as const, data: url };
}
